import Logo from "../../assets/images/un_resume_logo2.png";

export default function Navbar() {
  return (
    <nav className="flex items-center justify-start p-2 md:p-4 border-b border-b-gray-200 dark:border-b-gray-700 bg-white dark:bg-gray-900">
      <div className="ml-4 flex flex-row gap-x-2 items-center">
        <img alt="Company Logo" className="size-10" src={Logo} />
        <h2 className="font-bold text-xl tracking-tighter text-gray-900 dark:text-gray-100">
          UnResumé
        </h2>
      </div>
    </nav>
  );
}
